// extracted by mini-css-extract-plugin
export default {"subMenuList":"subMenuList-2DuMG","newSubMenuLabel":"newSubMenuLabel-1aUes","subMenuItem":"subMenuItem-3fObV","subMenuLink":"subMenuLink-2_XnS"};